module.exports = __webpack_public_path__ + "static/media/air-plane.c323c027.webp";